"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DifficultyLevel;
(function (DifficultyLevel) {
    DifficultyLevel[DifficultyLevel["BEGINNER"] = 1] = "BEGINNER";
    DifficultyLevel[DifficultyLevel["MODERATE"] = 2] = "MODERATE";
    DifficultyLevel[DifficultyLevel["INTERMEDIATE"] = 3] = "INTERMEDIATE";
    DifficultyLevel[DifficultyLevel["ADVANCED"] = 4] = "ADVANCED";
    DifficultyLevel[DifficultyLevel["OLYMPIC"] = 5] = "OLYMPIC";
})(DifficultyLevel || (DifficultyLevel = {}));
exports.default = DifficultyLevel;
//# sourceMappingURL=DifficultyLevel.js.map